import { render, staticRenderFns } from "./EmitirSunatMasivo.vue?vue&type=template&id=309d6b3c"
import script from "./EmitirSunatMasivo.vue?vue&type=script&lang=js"
export * from "./EmitirSunatMasivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports